<template>
  <div class="modal-mask" @mousedown.self.stop="closeModal">
    <div class="modal" @click.stop>
      <div class="modal__head">
        <h3 class="modal__title">{{ department.name }}</h3>
        <div class="close" @click.stop="closeModal">
          <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L16 16" stroke="currentColor" stroke-width="2"/>
            <path d="M1 16L16 1" stroke="currentColor" stroke-width="2"/>
          </svg>
        </div>
      </div>
      <div class="modal__body">
        <div class="item">
          <div class="data">ЦКП:</div>
          <div class="value">
            <span v-if="department.ckp">{{ department.ckp }}</span>
            <span v-else>Не определен</span>
          </div>
        </div>
        <div class="item">
          <div class="data">Обязанности:</div>
          <div class="value">
            <p class="duties-text" v-if="department.duties">{{ department.duties }}</p>
            <span v-else>Не определены</span>
          </div>
        </div>
        <div class="item">
          <div class="data">Должностные инструкции:</div>
          <div class="value">
            <a :href="department.instruction" target="_blank" class="link" title="Должностные инструкции" v-if="department.instruction">Открыть</a>
            <span v-else>Ссылка отсутствует</span>
          </div>
        </div>
        <div class="item">
          <div class="data">Папка штатного сотрудника:</div>
          <div class="value">
            <a :href="department.folder" target="_blank" class="link" title="Должностные инструкции" v-if="department.folder">Открыть</a>
            <span v-else>Ссылка отсутствует</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'department-detail-modal',
  components: {
  },
  props: {
    department: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
  },
  methods: {
    closeModal () {
      this.$store.dispatch('closeDetailDepartmentModal')
    }
  },
  mounted () {}
}
</script>

<style lang="scss" scoped>
@import '../../../assets/css/system/_vars';
@import '../../../assets/css/system/_mixins';

.modal-mask {
  overflow: auto;
  align-items: flex-start;
  padding-top: 10vh;
}

.modal {
  max-width: 840px;
}

.item {
  display: flex;
  flex-flow: row nowrap;

  &:last-child {
    margin-bottom: 0;
  }
}

.data {
  flex-shrink: 0;
  color: $color_second;
  font-weight: bold;
  width: 260px;
  margin-right: 46px;
  padding-bottom: 40px;
  border-right: 1px solid $border_color;
}

.value {
  padding-bottom: 40px;
}

.duties-text {
  white-space: pre-line;
}
</style>
